export default __webpack_public_path__ + "static/media/6f6228516d4c239768953b1a9166326a.1000a551.png";